import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: #DEDEDE;
  padding: 46px 0;
  .flex {
    justify-content: space-between;
    &.reverse {
      flex-direction: row-reverse;
      div .seal {
        right: inherit;
        left: -10px;
      }
    }
    @media (max-width: 540px) {
      flex-wrap: wrap;
    }
    div {
      width: 48%;
      height: 100%;
      position: relative;
      .seal {
        @media (min-width: 540px) {
          position: absolute;
          right: -10px;
          height: 120px;
          &.top {
            top: 20px;
          }
          &.middle {
            top: 50%;
            margin-top: -60px;
          }
          &.bottom {
            bottom: 20px;
          }
        }
        @media (max-width: 540px) {
          display: block;
          margin: 30px auto;
          text-align: center;
        }
        img {
          height: 120px;
          width: auto;
        }
      }
      @media (max-width: 540px) {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
  img {
    width: 100%;
  }
  .image {
    .title {
      @media (min-width: 789px) {
        display: none;
      }
    }
  }
  .text {
    .title {
      @media (max-width: 789px) {
        display: none;
      }
    }
  }
  h1,
  h2 {
    font: italic bold 36px 'Times new roman';
    margin: 0 0 20px;
  }
  h3 {
    font: italic bold 26px 'Times new roman';
    margin: 0 0 15px;
  }
  P {
    color: #616161;
    font-size: 14px;
    line-height: 24px;
  }
  a {
    cursor: pointer;
    max-width: 380px;
    width: 100%;
    background: #F1A857;
    display: flex;
    border-radius: 3px;
    border: 0;
    color: #fff;
    height: 60px;
    align-items: center;
    font-size: 16px;
    padding: 0;
    margin-top: 30px;
    text-decoration: none;
    @media (max-width: 1080px) {
      margin: 0 auto;
    }
    .text {
      height: 100%;
      flex-grow: 1;
      border-right: 1px solid #D99440;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
    }
    .icon {
      display: flex;
      align-items: center;
      min-width: 82px;
      justify-content: center;
      i {
        width: 24px;
        background: url(/images/streamline-icon-image-file-download@140x140@2x.png) center no-repeat;
        height: 24px;
        background-size: contain;
      }
    }
  }
`

const Block = ({ index, children, slug }) => {
  return (
    <Container id={ slug }>
      <div className={ `wrapper flex ${(index + 1) % 2 === 0 ? 'reverse' : '' }` }>
        { children }
      </div>
    </Container>
  )
}

export default Block;
